import { createContext } from 'react';

export type Platform = 'ios' | 'android';

export interface PlatformContextType {
  platform: Platform | null;
  setPlatform: (platform: Platform | null) => void;
}

export const PlatformContext = createContext<PlatformContextType | undefined>(
  undefined
);
